import React from "react";
import wrapComponentWithPopup, { PopupProps } from "../../../../../sharedComponents/wrapComponentWithPopup/wrapComponentWithPopup";
import WithPanelHeader from "../../../../../sharedComponents/WithPanelHeader";

type Props = PopupProps;

class InvitationFailurePopup extends React.PureComponent<Props, {}>  {
  render() {
    return (
      <WithPanelHeader title="Error" hideControls>
        <div className="component--invitation-failure-popup">
          <div className="text">
            Something went wrong, please send again.
          </div>

          <button onClick={this.props.closePopup}>Close</button>
        </div>
      </WithPanelHeader>
    );
  }
}

export default wrapComponentWithPopup(InvitationFailurePopup);
